import { useSelector } from "react-redux";
import { getIsLoggedInSelector, getActiveLocaleSelector } from "@americanexpress/travel-selectors";
import { clients, placements } from "../constants/moduleConstants";
import { useMembershipDomainFetchye } from "@americanexpress/consumer-travel-base";
import { MEMBERSHIP_DOMAIN_QUERY } from "../constants/membershipDomainConstants";
import { useArticlesHook } from "../oneData";
import { requiresMembershipDomain } from "../utils/membershipDomainUtils";
import { constructOneDataBody } from "../utils/oneDataBody";

type ArticlesParams = {
  clientId?: string;
  placementId?: string;
  articlesOverrideKey?: string;
};

export const useArticles = ({
  articlesOverrideKey,
  clientId,
  placementId,
}: ArticlesParams) => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const locale: string = useSelector(getActiveLocaleSelector);
  const isValidParams = clientId && placementId && clients.has(clientId) && placements.has(placementId);
  const {
    data: membershipData,
    isLoading: membershipDomainLoading,
  } = useMembershipDomainFetchye(MEMBERSHIP_DOMAIN_QUERY, {
    defer: !isLoggedIn || (!isValidParams && requiresMembershipDomain(placementId)),
  }, {});

  const oneDataBody = constructOneDataBody({
    locale, clientId, placementId
  }, membershipData);

  const {
    data: articlesData,
    isLoading: articlesLoading,
    error: articlesError,
  } = useArticlesHook({
    defer: !isValidParams || (isLoggedIn && membershipDomainLoading),
    body: JSON.stringify(oneDataBody),
  });

  return {
    /*
    * talking about the placementId.replace function,
    * will requset the one-data function to return the data behind the
    * kebab-case key rather than camelCase 
    */
    /* istanbul ignore next -- temporary whilst we test */
    data: articlesData?.body?.[articlesOverrideKey || placementId?.replace(/-./g, (x) => x[1].toUpperCase())],
    isLoading: articlesLoading || membershipDomainLoading,
    error: articlesError,
  };
}

